export function signInRequest(email, password) {
  return {
    type: '@auth/SIGN_IN_REQUEST',
    payload: { email, password },
  }
}

export function signInSuccess(token, user) {
  return {
    type: '@auth/SIGN_IN_SUCCESS',
    payload: { token, user },
  }
}

export function signFailure() {
  return {
    type: '@auth/SIGN_FAILURE',
  }
}

export function signUpRequest(name, email, password, roleId, askForPasswordChangeNextLogin) {
  return {
    type: '@auth/SIGN_UP_REQUEST',
    payload: { name, email, password, roleId, askForPasswordChangeNextLogin },
  }
}

export function signUpSuccess() {
  return {
    type: '@auth/SIGN_UP_SUCCESS',
  }
}

export function signOut() {
  return {
    type: '@auth/SIGN_OUT',
  }
}

export function signInSuccessChallenge() {
  return {
    type: '@auth/SIGN_IN_SUCCESS_CHALLENGE',
  }
}

export function changePasswordSignInRequest(data) {
  return {
    type: '@auth/CHANGE_PASSWORD_SIGN_IN_REQUEST',
    payload: { data },
  }
}
